// extracted by mini-css-extract-plugin
module.exports = {"dependency-list":"dependency-list-32eJG","dependencyList":"dependency-list-32eJG"};